import React from 'react'
import ReactDOM from 'react-dom/client'
import '@fontsource/inter'
import '@fontsource/inter/300.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import { initSentry } from 'utils/sentry'

import App from './App'

import './index.css'

initSentry()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// window.electron.ipcRenderer.on('custom-protocol-invoked', (event: any, url: string) => {
//   console.log('Received deep link:', url)
// })
